import { useNavigate } from "react-router-dom";
import MobileHeader from "../../../../layout/mobile-header";
import MobileTimerControllerBottom from "./components/bottom";
import { MobileControllerHeader, MobileControllerWrapper } from "./style";
import { useControllerContext } from "../../hooks/controller-context";
import { ControllerTab } from "../../hooks/use-controller-tab";
import MobileTimerControllerClock from "./components/clock";
import MobileTimerControllerSitIn from "./components/sit-in";
import { ControllerParticipation } from "../sit-in/components/participation";
import { useParticipantContext } from "../sit-in/hooks/participant-context";
import { MobileControllerReEntry } from "./components/re-entry";
import { Overlay } from "../../../../styles/popup";
import MobileTimerControllerPrizePage from "./components/prize";

const MobileTimerController = () => {
  const { isControllerTab, isPopup, data } = useControllerContext();
  const { isBuyInPopup, isReEntryPopup, reloadData } = useParticipantContext();
  const navigate = useNavigate();

  if (isControllerTab(ControllerTab.PRIZE)) {
    return <MobileTimerControllerPrizePage />;
  }

  return (
    <MobileControllerWrapper>
      {/* 참가 로직 팝업 */}
      {isBuyInPopup && <ControllerParticipation />}
      {/* 애드온 / 리바인 팝업 */}
      {isReEntryPopup && <MobileControllerReEntry />}
      <MobileHeader
        title="타이머 컨트롤러"
        show={true}
        back={() => navigate("/tournament")}
      />
      <MobileControllerHeader>
        <div className="box">
          <div className="title">{data?.title}</div>
          <div className="id">토너먼트 ID: {data?.id}</div>
        </div>
        <img
          src="/image-web/controller/reset.svg"
          alt="reset"
          onClick={() => reloadData()}
        />
      </MobileControllerHeader>
      {isControllerTab(ControllerTab.TOURNAMENT) && (
        <MobileTimerControllerClock />
      )}
      {isControllerTab(ControllerTab.SIT_IN) && <MobileTimerControllerSitIn />}
      {isPopup && <Overlay />}
      <MobileTimerControllerBottom />
    </MobileControllerWrapper>
  );
};

export default MobileTimerController;
